import { jsx as _jsx } from "react/jsx-runtime";
import { BottomSheetBodyContainer } from './styles/bottom-sheet-body.styled';
export const BottomSheetBody = ({ children, showFullHeight = false, dataTest = 'bottom-sheet-body', }) => (_jsx(BottomSheetBodyContainer, { "$showFullHeight": showFullHeight, "data-test": dataTest, children: children }));
BottomSheetBody.BOTTOMSHEET_ELEMENT = 'body';
